
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.815 15.92c.286-.452.9-.597 1.373-.323l10.622 6.157 10.332-6.151a1.026 1.026 0 011.377.307.934.934 0 01-.321 1.32L12.824 24 1.152 17.235a.935.935 0 01-.337-1.315z","fill":"#43D2C8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.815 11.512c.286-.452.9-.597 1.373-.323l10.622 6.157 10.332-6.15a1.026 1.026 0 011.377.307.934.934 0 01-.321 1.319l-11.374 6.77-11.672-6.764a.935.935 0 01-.337-1.316z","fill":"#5183D2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.815 7.105c.286-.452.9-.597 1.373-.323l10.622 6.156 10.332-6.15a1.026 1.026 0 011.377.307.934.934 0 01-.321 1.319l-11.374 6.771L1.152 8.42a.935.935 0 01-.337-1.315z","fill":"#823BD4"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.526 8.08c-.286.452-.9.597-1.373.323L12.53 2.247 2.2 8.397A1.026 1.026 0 01.822 8.09a.934.934 0 01.321-1.319L12.517 0 24.19 6.765a.935.935 0 01.337 1.315z","fill":"#823BD4"}})])
          )
        }
      }
    